module.exports = __webpack_public_path__ + "static/media/filter.c2844cce.svg";